import { render, staticRenderFns } from "./ReviewSummary.vue?vue&type=template&id=47aac28e&scoped=true"
import script from "./ReviewSummary.vue?vue&type=script&lang=js"
export * from "./ReviewSummary.vue?vue&type=script&lang=js"
import style0 from "./ReviewSummary.vue?vue&type=style&index=0&id=47aac28e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aac28e",
  null
  
)

export default component.exports